import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../ChooseUs/ChooseUs.css";

const ChooseUs = () => {

  const API = "/api/chooseus";

  const [header, setHeader] = useState("");
  const [slogan, setSlogan] = useState("");
  const [image, setImage] = useState("");
  const [points, setPoints] = useState([]);

  /* FETCH SECTION DATA */

  const fetchSection = async () => {
    try {

      const res = await axios.get(`${API}/section`);

      if (res.data) {

        setHeader(res.data.header || "");

        setSlogan(
          res.data.slogan ||
          "Nurturing Knowledge • Building Character • Creating Leaders"
        );

        if (res.data.image) {
          setImage(
            `${BASE_URL}/uploads/chooseus/${res.data.image}`
          );
        }

      }

    } catch (err) {
      console.error("Section load error:", err);
    }
  };


  /* FETCH POINTS */

  const fetchPoints = async () => {
    try {

      const res = await axios.get(API);

      setPoints(res.data);

    } catch (err) {
      console.error("Points load error:", err);
    }
  };


  /* LOAD DATA */

  useEffect(() => {

    fetchSection();
    fetchPoints();

  }, []);


  return (

    <section className="chooseus-section">

      <div className="container chooseus-container">

        {/* TOP HEADING */}

        <div className="chooseus-heading text-center">

          <p className="chooseus-slogan">
            {slogan}
          </p>

          <h2 className="chooseus-title">
            {header}
          </h2>

          <div className="chooseus-divider"></div>

        </div>


        {/* IMAGE ABOVE CONTENT */}

        {image && (
          <div className="chooseus-image-top">

            <img
              src={image}
              alt={header}
              className="img-fluid"
            />

          </div>
        )}


        {/* CONTENT GRID */}

        <div className="row chooseus-content">

          {points.map((item, index) => {

            const cleanText = item.descr.replace(/^\d+\.\s*/, "");

            return (

              <div
                className="col-lg-6 col-md-6 col-sm-12"
                key={item.id}
              >

                <div className="chooseus-card">

                  <div className="chooseus-number">
                    {(index + 1).toString().padStart(2, "0")}
                  </div>

                  <div className="chooseus-text">
                    {cleanText}
                  </div>

                </div>

              </div>

            );

          })}

        </div>


        {/* IMAGE BELOW CONTENT */}

        {image && (
          <div className="chooseus-image-bottom">

            <img
              src={image}
              alt="school environment"
              className="img-fluid"
            />

          </div>
        )}

      </div>

    </section>

  );
};

export default ChooseUs;